import types from '../mutation-types';
import information from 'dashboard/api/information';

export const state = {
  userQuestions: {
    tableData: [],
  },
  questionsTagList: {
    tableData: [],
  },
  questionsTypeList: {
    tableData: [],
  },
  functionTriggerList: {
    tableData: [],
  },
  robotNotMatchedList: {
    tableData: [],
  },
  messageData: {
    data: [],
  },
};

export const getters = {
  //  获取会话记录
  userQuestionsList(_state) {
    return _state.userQuestions.tableData;
  },
  questionsTagList(_state) {
    return _state.questionsTagList.tableData;
  },
  questionsTypeList(_state) {
    return _state.questionsTypeList.tableData;
  },
  functionTriggerList(_state) {
    return _state.functionTriggerList.tableData;
  },
  robotNotMatchedList(_state) {
    return _state.robotNotMatchedList.tableData;
  },
  messageData(_state) {
    return _state.messageData.data;
  },
};

export const actions = {
  async getUserQuestionsList({ commit }, { page = 1, from, to } = {}) {
    // commit(types.SET_CSAT_RESPONSE_UI_FLAG, { isFetching: true });
    try {
      const response = await information.getUserQuestionsList({
        page,
        from,
        to,
      });
      commit(types.SET_INFORMATION_USER_QUESTIONS, response.data);
    } catch (error) {
      // Ignore error
    } finally {
      // commit(types.SET_CSAT_RESPONSE_UI_FLAG, { isFetching: false });
    }
  },
  async getQuestionsTagList({ commit }, { page = 1, from, to } = {}) {
    // commit(types.SET_CSAT_RESPONSE_UI_FLAG, { isFetching: true });
    try {
      const response = await information.getQuestionsTagList({
        page,
        from,
        to,
      });
      commit(types.SET_INFORMATION_QUESTIONS_TAGS, response.data);
    } catch (error) {
      // Ignore error
    } finally {
      // commit(types.SET_CSAT_RESPONSE_UI_FLAG, { isFetching: false });
    }
  },
  async getQuestionsTypeList({ commit }, { page = 1, from, to } = {}) {
    // commit(types.SET_CSAT_RESPONSE_UI_FLAG, { isFetching: true });
    try {
      const response = await information.getQuestionsTypeList({
        page,
        from,
        to,
      });
      commit(types.SET_INFORMATION_QUESTIONS_TYPES, response.data);
    } catch (error) {
      // Ignore error
    } finally {
      // commit(types.SET_CSAT_RESPONSE_UI_FLAG, { isFetching: false });
    }
  },
  async getFunctionTriggerList({ commit }, { page = 1, from, to } = {}) {
    // commit(types.SET_CSAT_RESPONSE_UI_FLAG, { isFetching: true });
    try {
      const response = await information.getFunctionTriggerList({
        page,
        from,
        to,
      });
      commit(types.SET_INFORMATION_FUNCTION_TRIGGER, response.data);
    } catch (error) {
      // Ignore error
    } finally {
      // commit(types.SET_CSAT_RESPONSE_UI_FLAG, { isFetching: false });
    }
  },
  async getRobotNotMatchedList({ commit }, { page = 1, from, to } = {}) {
    // commit(types.SET_CSAT_RESPONSE_UI_FLAG, { isFetching: true });
    try {
      const response = await information.getRobotNotMatchedList({
        page,
        from,
        to,
      });
      commit(types.SET_INFORMATION_ROBOT_NOT_MATCHED, response.data);
    } catch (error) {
      // Ignore error
    } finally {
      // commit(types.SET_CSAT_RESPONSE_UI_FLAG, { isFetching: false });
    }
  },
  async getMessageData({ commit }, { id } = {}) {
    // commit(types.SET_CSAT_RESPONSE_UI_FLAG, { isFetching: true });
    try {
      const response = await information.getMessageData({ id });
      commit(types.SET_INFORMATION_MESSAGE_DATA, response.data);
    } catch (error) {
      // Ignore error
    } finally {
      // commit(types.SET_CSAT_RESPONSE_UI_FLAG, { isFetching: false });
    }
  },
};

export const mutations = {
  [types.SET_INFORMATION_USER_QUESTIONS](_state, data) {
    _state.userQuestions.tableData = data;
  },
  [types.SET_INFORMATION_QUESTIONS_TAGS](_state, data) {
    _state.questionsTagList.tableData = data;
  },
  [types.SET_INFORMATION_QUESTIONS_TYPES](_state, data) {
    _state.questionsTypeList.tableData = data;
  },
  [types.SET_INFORMATION_FUNCTION_TRIGGER](_state, data) {
    _state.functionTriggerList.tableData = data;
  },
  [types.SET_INFORMATION_ROBOT_NOT_MATCHED](_state, data) {
    _state.robotNotMatchedList.tableData = data;
  },
  [types.SET_INFORMATION_MESSAGE_DATA](_state, data) {
    _state.messageData.data = data;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
